module.exports = __webpack_public_path__ + "static/media/Bringing the Speed and Power of GPU Rendering to Arnold.509c38cf.png";